import * as React from 'react';
import * as Tgcc from '../tgccGlobal';
import { browserHistory } from 'react-router';
import { FaHardHat, FaTshirt } from 'react-icons/fa';

// ----- Animated Gradient Support (shared once per session) -----
const ensureGradientKeyframes = () => {
  if (typeof document === 'undefined') return;
  if (document.getElementById('pj-gradient-anim')) return;
  const style = document.createElement('style');
  style.id = 'pj-gradient-anim';
  style.innerHTML = `
    @keyframes gradientBackground {
      0% { background-position: 0% 50%; }
      50% { background-position: 100% 50%; }
      100% { background-position: 0% 50%; }
    }
  `;
  document.head.appendChild(style);
};
ensureGradientKeyframes();

// ------------------- Inline Styles -------------------
const styles: { [key: string]: React.CSSProperties } = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    background: 'linear-gradient(270deg, #008e6a, #00a77d, #D22328, #0099ff)',
    backgroundSize: '800% 800%',
    animation: 'gradientBackground 15s ease infinite',
    color: '#FFF',
    fontFamily: "'Montserrat', sans-serif",
    padding: '20px',
    textAlign: 'center',
    transition: 'opacity 0.5s ease',
    opacity: 0.95,
  },
  header: {
    margin: '0 0 20px 0',
    fontSize: '2.5em',
    fontWeight: 'bold',
  },
  description: {
    fontSize: '1.2em',
    maxWidth: '600px',
    lineHeight: '1.5',
  },
  button: {
    fontSize: '1em',
    padding: '15px 30px',
    backgroundColor: '#FFF',
    color: '#008e6a',
    border: '2px solid #FFF',
    borderRadius: '50px',
    boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
    cursor: 'pointer',
    textDecoration: 'none',
    display: 'inline-block',
    marginTop: '20px',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease, background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease',
  },
};

interface Props {}
interface State {}

class PapaJohnsDesignSelectUC extends React.Component<Props, State> {
  handleCTA = () => {
    browserHistory.push(Tgcc.Routes.PapaJohnsShirtOfTheMonthClub);
  };

  render() {
    return (
      <div style={styles.container}>
        <h1 style={styles.header}>
          <FaHardHat style={{ marginRight: '10px', verticalAlign: 'middle', fontSize: '1.5em' }} />
          Page Under Construction
        </h1>
        <p style={styles.description}>
          We're busy crafting an improved design selection experience. Until then, check out our Shirt of the Month!
        </p>
        <button
          style={styles.button}
          onClick={this.handleCTA}
          onMouseEnter={e => {
            const b = e.currentTarget.style;
            b.transform = 'scale(1.05)';
            b.boxShadow = '0 8px 16px rgba(0,0,0,0.3)';
            b.backgroundColor = '#D22328';
            b.color = '#FFF';
            b.borderColor = '#008e6a';
          }}
          onMouseLeave={e => {
            const b = e.currentTarget.style;
            b.transform = 'scale(1)';
            b.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
            b.backgroundColor = '#FFF';
            b.color = '#008e6a';
            b.borderColor = '#FFF';
          }}
        >
          <FaTshirt style={{ marginRight: '10px', verticalAlign: 'middle', fontSize: '1.2em' }} />
          Explore Shirt of the Month
        </button>
      </div>
    );
  }
}

export const PapaJohnsDesignSelect = PapaJohnsDesignSelectUC;

/*
====================================================
ORIGINAL VERSION (commented out for future reference)
====================================================
// 1→declare const AssetRoot: string;
// 2→import * as React from 'react';
// 3→import * as Request from '../tgccRequest';
// 4→import  PapaJohnsBannerImage  from './PapaJohnsBannerImage';
// 5→import Radium from 'radium';
// 6→import { connect } from 'react-redux';
// 7→import * as Tgcc from '../tgccGlobal';
// 8→import { browserHistory } from 'react-router';
// 9→import ProgressBar from '../Components/ProgressBar';
// 10→import BackButton from '../Components/BackButton';
// 11→
// 12→type Styles = {
// 13→  [key: string]: React.CSSProperties;
// 14→};
// 15→const keyframes = (Radium as any).keyframes as (
// 16→  frames: { [percent: string]: React.CSSProperties },
// 17→  name?: string
// 18→) => string;
// 19→
// 20→const pulseKeyframes = keyframes({
// 21→  '0%':   { transform: 'scale(1.0)' },
// 22→  '50%':  { transform: 'scale(1.05)' },
// 23→  '100%': { transform: 'scale(1.0)' }
// 24→}, 'pulse');
// 25→
// 26→const styles: Styles = {
// 27→
// 28→  buttonStyle : {
// 29→    padding: '15px 30px',
// 30→    fontSize: '1.2rem',
// 31→    color: '#fff',
// 32→    position: 'relative', // Position the button relatively to the container
// 33→    top: '20px', // Move button up by its height
// 34→    zIndex: 2, // Ensure button is above other content
// 35→    margin: '0 auto',
// 36→    backgroundColor: 'rgb(210, 35, 40)',
// 37→    border: 'none',
// 38→    borderRadius: '5px',
// 39→    cursor: 'pointer',
// 40→    display: 'block',
// 41→    alignSelf: 'center', // Center the button within the flex container
// 42→    transition: 'transform 0.2s, box-shadow 0.2s', // Smooth transition for interaction
// 43→    animation: `${pulseKeyframes} 3s ease-in-out infinite`,
// 44→    ':hover': {
// 45→      transform: 'scale(1.05)',
// 46→      boxShadow: '0 6px 12px rgba(0, 0, 0, 0.3)',
// 47→      backgroundColor: '#e60000', // change color on hover
// 48→    },
// 49→  },
// 50→
// 51→  container: {
// 52→    display: 'flex',
// 53→    flexDirection: 'column',
// 54→    alignItems: 'center',
// 55→    justifyContent: 'space-between',
// 56→    backgroundColor: '#f2f2f2',
// 57→    padding: '40px 20px 20px',
// 58→    fontFamily: "'Montserrat', sans-serif",
// 59→    width: '100%',
// 60→    height: 'auto', // Adjust height to content
// 61→    minHeight: '100vh', // Minimum height of the viewport
// 62→  },
// 63→
// 64→  title: {
// 65→    fontSize: '2.5rem', // Larger font size for prominence
// 66→    fontWeight: 'bold', // Make the font bold
// 67→    color: '#333', // Dark color for the text
// 68→    textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)', // Text shadow for depth
// 69→    textAlign: 'center', // Ensure the title is centered
// 70→  },
// 71→
// 72→  previewContainer: {
// 73→    flexDirection: 'column',
// 74→    position: 'relative', // Establish this container as the positioning context for the button
// 75→    display: 'flex',
// 76→    justifyContent: 'center',
// 77→    alignItems: 'center',
// 78→    padding: '20px',
// 79→    flexGrow: 0, // Do not allow the preview to grow; remove if you're setting a fixed width
// 80→    flexShrink: 0,
// 81→
// 82→    margin: '-10px auto', // Center in the available space
// 83→    maxWidth: '500px', // Maximum width for the preview
// 84→    height: 'auto', // Height adjusts to content
// 85→  },
// 86→  confirmButtonContainer: {
// 87→    alignSelf: 'center',
// 88→    position: 'absolute', // Adjust position to float above the preview container
// 89→    top: 0, // Align the button to the top of the preview container
// 90→    left: '50%', // Center the button with respect to the container
// 91→    transform: 'translate(-50%, -100%)', // Adjust horizontal position by 50% of its width and move it up by 100% of its height
// 92→    zIndex: 10, // Ensure the button is abov
// 93→  },
// ... (many lines omitted for brevity) ...
// 486→}
// 487→
// 488→export const PapaJohnsDesignSelect = connect(mapStateToProps)(Radium(_PapaJohnsDesignSelect));
// 489→
*/